// src/firebase/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";



const firebaseConfig = {
  apiKey: "AIzaSyBwv2CW-4OXIfkOFVWAgb1DP4TgL3zGVC8",
  authDomain: "quyenxdclass.com",
  projectId: "quyenxdclass",
  storageBucket: "quyenxdclass.firebasestorage.app",
  messagingSenderId: "433675638191",
  appId: "1:433675638191:web:c28487eb376fefb4e5cb5a",
  measurementId: "G-R0Z02EGSW6"
};

if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"||
  window.location.hostname.indexOf('quyenxdclass--test-beta')>=0
) {
  // Chỉ dùng khi chạy dev/localhost
  // Đảm bảo gán trước khi init AppCheck
try {
  const saved = localStorage.getItem("APP_CHECK_DEBUG_TOKEN");
  const isUuidV4 = (s) =>
    /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(s || "");
  if (saved === "true") window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  else if (isUuidV4(saved)) window.FIREBASE_APPCHECK_DEBUG_TOKEN = saved;
} catch {}
  // window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// ✅ Initialize and export app
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

// KẾT NỐI VỚI FIRESTORE EMULATOR
// Đảm bảo bạn chỉ chạy dòng này khi ở môi trường phát triển (ví dụ: kiểm tra process.env.NODE_ENV)
// Để tránh việc ứng dụng production của bạn kết nối với emulator

if (false && window.location.hostname === "localhost") { // Hoặc bất kỳ điều kiện nào bạn dùng cho dev
  connectFirestoreEmulator(getFirestore(app), "localhost", 8080); // Cổng mặc định là 8080
  console.log("Connected to Firestore emulator!");
}

const db = getFirestore(app);
const auth = getAuth(app); // nếu dùng ở chỗ khác
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LcGJIwrAAAAALC3seKi_S1Gj8RDyagfDDCN1fgL"),
  isTokenAutoRefreshEnabled: true, // nên bật cho web app
});

// console.log("App Check initialized!", appCheck);


export { app }; // ✅ Thêm dòng này để dùng được ở AuthContext
export { auth, db, storage, appCheck };

